//angular imports
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { PortalModule } from "@angular/cdk/portal";
import { RouterModule } from "@angular/router";

//ngx imports
import { AccordionModule } from "ngx-bootstrap/accordion";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { BsModalService } from "ngx-bootstrap/modal";
import { QuillModule } from "ngx-quill";

//local imports

import { Messenger } from "./data";

import { SharedComponentServices, SharedComponents } from "./components";

import { SharedDirectives } from "./directives";
import { TabsModule } from "ngx-bootstrap/tabs";


@NgModule({
    declarations: [
        ...SharedComponents,
        ...SharedDirectives
    ],
    imports: [
        TabsModule,
        CommonModule,        
        FormsModule,
        ReactiveFormsModule,
        PortalModule,        
        AccordionModule,
        RouterModule,
        TooltipModule,
        BsDropdownModule,
        CarouselModule,
        QuillModule
    ],
    exports: [
        ...SharedComponents,
        ...SharedDirectives
    ] 
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [Messenger, BsModalService, ...SharedComponentServices],
    };
  }
}
